import React, { useEffect } from 'react';
import { Select } from 'antd';
import { useModalWatch } from '../../../../shared/packages/modalManager';
import { modalNames } from '../../../../shared/configs/modal';
import FetchDataWrapper from '../../../../../../components/FetchDataWrapper';
import { useFieldController } from '../../../../../../helpers/formManager';
import { fieldNames } from '../../constants';
import Field from '../../../../shared/ui/Field';
import { useAttachmentTypesQuery } from '../../../../api/attachmentTypes';

const emptyArr = [];
const modalName = modalNames.attachmentsForm;
const SelectType = () => {
  const addressId = useModalWatch({
    name: modalName,
    selector: (state) => state?.props?.room?.id,
  });

  const acceptanceClientId = useModalWatch({
    name: modalName,
    selector: (state) => state?.props?.record?.id,
  });

  const { data, isFetching, refetch } = useAttachmentTypesQuery({
    params: { addressId, acceptanceClientId },
  });

  const controller = useFieldController({
    name: fieldNames.typeId,
    rules: { required: 'Выберите тип документа' },
  });

  return (
    <FetchDataWrapper
      data={data}
      isFetching={isFetching}
      refetch={refetch}
      errMsg="Не удалось получить доступные типы документов"
      ignoreEmpty
    >
      <SelectBase
        data={Array.isArray(data) ? data : emptyArr}
        controller={controller}
      />
    </FetchDataWrapper>
  );
};

export default SelectType;

function SelectBase({ data, controller }) {
  const {
    field: { value, onChange },
    fieldState,
  } = controller;

  const handleChange = (value) => {
    onChange(value);
  };

  useEffect(() => {
    if (data?.length === 1 && !value) {
      onChange(data[0].id);
    }
  }, [value, onChange, data]);

  return (
    <Field.Memoized
      type={Field.types.select}
      value={data?.length ? value : undefined}
      onChange={handleChange}
      formItemLabel="Тип документа"
      required
      style={{ width: '100%' }}
      optionFilterProp="search"
      showSearch={data.length > 10}
      errorMessage={fieldState.error?.message}
    >
      {data?.map((item) => (
        <Select.Option key={item.id} value={item.id} search={item.name}>
          {item.name}
        </Select.Option>
      ))}
    </Field.Memoized>
  );
}
